import React from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import useI18n from '@/hooks/useI18n'

// Methods
import { getCompanyBrandName, getCompanyNameDefault } from '@/components/pages/Terms/methods/company'

// Styles
import styles from './style.module.scss'

// Variable
const cx = classnames.bind(styles)

const PrivacyPolicy = () => {
  const { t } = useTranslation()
  const { isOverseaUser } = useI18n()

  return (
    <div className={cx('privacy-policy__container')}>
      <div className={cx('privacy-policy')}>
        <div className={cx('privacy-policy__title')}>{t('Privacy_Policy_Title', { brandName: getCompanyBrandName(isOverseaUser) })}</div>

        <div>
          {t('Privacy_Policy_Description', {
            brandName: getCompanyBrandName(isOverseaUser),
            companyNameDefault: getCompanyNameDefault(isOverseaUser, t),
          })}
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_1')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_1', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_2')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_2', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_3')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_3', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_4')}</div>
          <div className={cx('privacy-policy__section-list')}>{t('Privacy_Policy_Description_4')}</div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_5')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_5', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_6')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_6', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_7')}</div>
          <div className={cx('privacy-policy__section-list')}>{t('Privacy_Policy_Description_7')}</div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_8')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_8', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_9')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_9', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>

        <div className={cx('privacy-policy__section')}>
          <div className={cx('privacy-policy__section-title')}>{t('Privacy_Policy_Title_10')}</div>
          <div className={cx('privacy-policy__section-list')}>
            {t('Privacy_Policy_Description_10', { brandName: getCompanyBrandName(isOverseaUser) })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
